import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { trackByIndex } from 'src/app/shared/utils/track-by.util';

export interface BreakdownDialogData {
    period: string;
    total: number;
    prior: number | null;
    rows: { name: string; value: number }[];
}

@Component({
    standalone: true,
    selector: 'app-sample-collection-metrics-breakdown-dialog',
    imports: [TranslateModule, MatDialogModule],
    templateUrl: './sample-collection-metrics-breakdown-dialog.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./sample-collection-metrics-breakdown-dialog.component.scss']
})
export class SampleCollectionMetricsBreakdownDialogComponent {
    public trackByIndex = trackByIndex;

    constructor(
        private dialogRef: MatDialogRef<SampleCollectionMetricsBreakdownDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: BreakdownDialogData
    ) {}

    close(): void {
        this.dialogRef.close();
    }
}
